import './style.css';

import React from 'react';
import ReactTooltip from "react-tooltip";

const TooltipPassword = () => {
    return (
        <div className={"tooltip-password"} data-tip data-for='passwordRules'>
            <i className="fa fa-question-circle"></i>
            <ReactTooltip place='top' type='info' effect='solid' id='passwordRules'>
                <div className={"tooltip-rules"}>
                    <p>A senha nova deve seguir as regras abaixo:</p>
                    <ul>
                        <li>Ser diferente das 5 últimas senhas utilizadas</li>
                        <li>Possuir ao menos 14 caracteres</li>
                        <li>Possuir ao menos um número</li>
                        <li>Possuir ao menos um caractere maiúsculo</li>
                        <li>Possuir ao menos um caractere minusculo</li>
                        <li>Possuir ao menos um caractere especial</li>
                    </ul>
                </div>
            </ReactTooltip>
        </div>
    )
};

export default TooltipPassword;
